import { createContext, useContext } from "react";

interface RouterValue {
  navigate: (to: string) => void;
  params: Record<string, string>;
  pathname: string;
}

export const RouterCtx = createContext<RouterValue>({
  navigate: () => {},
  params: {},
  pathname: "/",
});

export function useNavigate() {
  return useContext(RouterCtx).navigate;
}

export function useParams() {
  return useContext(RouterCtx).params;
}

export function usePathname() {
  return useContext(RouterCtx).pathname;
}
